import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'sh-platform-switch',
  templateUrl: './platform-switch.component.html',
  styleUrl: './platform-switch.component.scss',
  standalone: false
})
export class PlatformSwitchComponent implements OnInit {
  form = new FormGroup({
    switch: new FormControl(true),
    switchDefaultFalse: new FormControl(false),
    switchDisabled: new FormControl(false)
  });

  usage = `
          <ui-platform-switch
            formControlName="switch"
            [label]="'Switch toggle'"
          >
          </ui-platform-switch>
    `;

  import = `
    import {UiPlatformSwitch} from 'ui-platform';
  `;

  visible = true;
  inProgress = false;

  constructor() {}

  ngOnInit(): void {}

  makeVisible(): void {
    this.visible = true;
  }

  closeDrawer(): void {
    this.visible = false;
  }

  toggleInProgress(): void {
    this.inProgress = !this.inProgress;
  }
}
